import Information from './components/Information.vue';
import CalculationTable from './components/calculateTable/CalculationTable.vue';
import ProjectingForm from './components/form/Form.vue';
import Chat from './components/chat/Chat.vue';

export default {
  name: 'ProjectingItem',

  components: {
    Information,
    CalculationTable,
    ProjectingForm,
    Chat,
  },

  props: ['id', 'tab'],

  data() {
    return {
      activeTab: 0,
      dialog: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    item() {
      return this.$store.state.design.projecting;
    },
  },
  methods: {
    showBtnStatus(status) {
      let res = false;
      switch (status) {
        case 'cancel':
          res = this.item?.status !== 'points_awarded' && this.item?.status !== 'refusal'
            && this.item?.status !== 'paid' && this.item?.status !== 'payment_confirmed'
            && this.item?.status !== 'document_preparation project_ready' && this.item?.status !== 'project_ready'
            && this.item?.status !== 'equipment_purchased';
          break;
        case 'edit':
          res = this.item?.status === 'draft' || this.item?.status === 'under_revision';
          break;
        case 'confirm_estimate':
          res = this.item?.status === 'estimate_ready';
          break;
        case 'confirm_pay':
          res = this.item?.status === 'awaiting_payment';
          break;
        case 'send_check':
          res = this.item?.status === 'project_ready';
          break;
        default:
          res = false;
      }
      return res;
    },
    setStatus(status) {
      const app = this;
      const application = {
        application_id: this.id,
        profile_id: this.user.profile_id,
        status,
      };
      app.$store.getters.axl
        .post('design/api/application/update-status', application)
        .then(() => {
          this.$store.dispatch('design/ProjectingGetView', {
            profile_id: this.user.profile_id,
            application_id: this.id,
          });
          app.$store.dispatch('ShowInfo', 'Статус заявки изменен');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    closeDialog() {
      this.dialog = false;
    },
    statusClass(status) {
      switch (status) {
        case 'refusal':
        case 'rejected':
          return '_red';
        case 'under_review':
        case 'under_revision':
        case 'awaiting_payment':
        case 'document_preparation':
          return '_orange';
        case 'estimate_ready':
        case 'paid':
        case 'payment_confirmed':
        case 'equipment_purchased':
          return '_blue';
        case 'points_awarded':
        case 'estimate_confirmed':
        case 'project_ready':
          return '_green';
        default:
          return '_grey';
      }
    },
  },
  mounted() {
    const app = this;
    this.$store.dispatch('design/ProjectingGetView', {
      profile_id: this.user.profile_id,
      application_id: this.id,
    });
    this.$store.dispatch('SetTitle', 'Проектирование');
    setTimeout(() => {
      // eslint-disable-next-line
      document.getElementsByClassName('v-tab')[app.tab].click()
    }, 1000);
  },
};
